<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(1 1)">
    <ellipse stroke-width="0" opacity="0.5" fill="#000" cx="29" cy="29" rx="29" ry="29"/>
    <path fill="#fff" stroke="#444" stroke-width="0" d="M21.007 16.778v25.08c-.005.416.232.8.613.996.381.196.844.17 1.2-.064l18.812-12.54c.316-.213.505-.56.505-.932 0-.371-.189-.72-.505-.932l-18.811-12.54a1.197 1.197 0 00-1.201-.064c-.381.196-.618.58-.613.996z"/>
    <ellipse style="opacity: 0; animation: svg-touch-animation-1 2s infinite;" cx="29" cy="29" rx="27" ry="27"/>
    <ellipse style="opacity: 0; animation: svg-touch-animation-2 2s infinite;" cx="29" cy="29" rx="28" ry="28"/>

  </g>
</svg>
</template>


<style>
    @-webkit-keyframes svg-play-animation-1 {
        0% {
            opacity: 0;
        }
        15% {
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        65% {
            opacity: 0;
        }
        80% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }
        @-webkit-keyframes svg-play-animation-2 {
        0% {
            opacity: 0;
        }
        25% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        75% {
            opacity: 0;
        }
        90% {
            opacity: 0;
        }
    }
</style>

<script>
// https://www.iconfinder.com/icons/329390/double_finger_gesture_hand_tap_icon
export default {
    props: {
        animated: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {

    },
};
</script>

